import { useCallback } from "preact/hooks"
import { trackQuestionCompleted } from "landing_pages/tracking"
import { QuestionProps } from "landing_pages/types"
import { FunctionalComponent } from "preact"

export default function Question({questionComponent: QuestionComponent, ...props}: { questionComponent: FunctionalComponent<QuestionProps> } & QuestionProps) {
  const trackChange = useCallback(() => {
    trackQuestionCompleted(props.question.key, props.question.text, props.currentStep)
  }, [props.currentStep, props.question.key, props.question.text])

  return (
    <QuestionComponent
      {...props}
      onCommit={() => { trackChange(); props.onCommit?.() }}
    />
  )
}
